module.exports = __webpack_public_path__ + "img/cw.31ab367a.svg";